import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { IAction } from "../../../../models/Action";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { compose } from "redux";
import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  WORKFLOW,
  WORKFLOW_STEP,
  WORKFLOW_STEP_CONFIGURATION,
  WORKFLOW_TABLE,
  WORKFLOW_STEP_TABLE,
  WORKFLOW_STEP_CONFIGURATION_TABLE,
  MATCHING_RULES,
  RULES,
  ADDED,
  MODIFIED,
  REQUEST_STATE,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.WORKFLOW_REQUEST]: (state: any, action: any) =>
    immutableSet([WORKFLOW, WORKFLOW_TABLE, LOADER_IDENTIFIER], true, state),
  [actionTypes.WORKFLOW_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.workflow.length > 0 &&
      action.payload.workflow.forEach((data: any) => {
        const tempRow: {} = {
          id: data.id,
          description: data.description,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet([WORKFLOW, WORKFLOW_TABLE, LIST_IDENTIFIER], mappedResponse),
      immutableSet([WORKFLOW, WORKFLOW_TABLE, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.WORKFLOW_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([WORKFLOW, WORKFLOW_TABLE, LOADER_IDENTIFIER], false, state),
  [actionTypes.WORKFLOW_STEP_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, LOADER_IDENTIFIER],
      true,
      state
    ),
  [actionTypes.WORKFLOW_STEP_REQUEST_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.workflowSteps.length > 0 &&
      action.payload.workflowSteps.forEach((data: any) => {
        const tempRow: {} = {
          id: data.id,
          min_approval: data.minApproval,
          step_order: data.stepOrder,
          workflow_id: data.workflowId,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet(
        [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },
  [actionTypes.WORKFLOW_STEP_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, LOADER_IDENTIFIER],
      false,
      state
    ),
  [actionTypes.WORKFLOW_STEP_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        LOADER_IDENTIFIER,
      ],
      true,
      state
    ),
  [actionTypes.WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.stepsConfiguration.length > 0 &&
      action.payload.stepsConfiguration.forEach((data: any) => {
        const tempRow: {} = {
          uniqueId: data.stepCode,
          step_code: data.stepCode,
          approver: data.approver,
          is_role: `${data.isRole}`,
          min_approval: data.minApproval,
          step_description: data.stepDescription,
          step_id: data.stepId,
          is_reject_atomic: `${data.isRejectAtomic}`,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [
          WORKFLOW_STEP_CONFIGURATION,
          WORKFLOW_STEP_CONFIGURATION_TABLE,
          LIST_IDENTIFIER,
        ],
        mappedResponse
      ),
      immutableSet(
        [
          WORKFLOW_STEP_CONFIGURATION,
          WORKFLOW_STEP_CONFIGURATION_TABLE,
          LOADER_IDENTIFIER,
        ],
        false
      )
    )(state);
  },
  [actionTypes.WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        LOADER_IDENTIFIER,
      ],
      false,
      state
    ),

  [actionTypes.CREATE_WORKFLOW_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.CREATE_WORKFLOW_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.CREATE_WORKFLOW_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW, WORKFLOW_TABLE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.CREATE_WORKFLOW_STEP_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.CREATE_WORKFLOW_STEP_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.CREATE_WORKFLOW_STEP_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_STEP_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_STEP_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_STEP_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_STEP_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_STEP_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_STEP_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [WORKFLOW_STEP, WORKFLOW_STEP_TABLE, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.CREATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.ERROR,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.UPDATE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.ERROR,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.DELETE_WORKFLOW_STEP_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        WORKFLOW_STEP_CONFIGURATION,
        WORKFLOW_STEP_CONFIGURATION_TABLE,
        REQUEST_STATE,
      ],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.MATCHING_RULES]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.MATCHING_RULES_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.MATCHING_RULES_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.SAVE_WORKFLOW]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.SAVE_WORKFLOW_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.SAVE_WORKFLOW_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_MATCHING_RULES_REQUEST]: (state: any, action: any) =>
    immutableSet([MATCHING_RULES, LOADER_IDENTIFIER], true, state),
  [actionTypes.GET_MATCHING_RULES_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    const tempRow: {} = {
      id: action.payload.id,
      rules: action.payload.rules,
    };
    mappedResponse.push(tempRow);
    return compose(
      immutableSet([MATCHING_RULES, RULES], mappedResponse),
      immutableSet([MATCHING_RULES, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.GET_MATCHING_RULES_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([MATCHING_RULES, LOADER_IDENTIFIER], false, state),

  [actionTypes.UPDATE_MATCHING_RULES]: (state: any, action: any) =>
    immutableSet(
      [MATCHING_RULES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),
  [actionTypes.UPDATE_MATCHING_RULES_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [MATCHING_RULES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),
  [actionTypes.UPDATE_MATCHING_RULES_FAILURE]: (state: any, action: any) =>
    immutableSet([MATCHING_RULES, REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_MATCHING_RULES]: (state: any, action: any) => {
    return compose(
      immutableSet([MATCHING_RULES, RULES], []),
      immutableSet([MATCHING_RULES, LOADER_IDENTIFIER], false),
      immutableSet([MATCHING_RULES, REQUEST_STATE], IResponseState.PENDING)
    )(state);
  },

  [actionTypes.RESET_STATE_WORKFLOW_MANAGEMENT]: (state: any, action: any) =>
    emptyState,
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
